import { gql } from "@apollo/client";

export const ALLERGENS_FRAGMENT = gql`
  fragment AllergensFragment on MenuItem {
    sugarFree
    glutenFree
    cornFree
    dairyFree
    eggsFree
    fishFree
    legumesFree
    peanutFree
    seedsFree
    shellfishFree
    treeNutsFree
  }
`;

export const WEIGHT_FRAGMENT = gql`
  fragment WeightFragment on MenuItem {
    amount
    unit
    amountInBase
    mass
  }
`; 

export const FOOD_ENERGY_FRAGMENT = gql`
  fragment FoodEnergyFragment on MenuItem {
    proteins
    fats
    carbohydrates
    calories
  }
`;
